/**
 * Dynamic onboarding step loader.
 *
 * Reads `:stepId` from URL params, looks up the component in the
 * step registry, and renders it inside a Suspense boundary.
 */
import { Suspense } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { STEP_COMPONENTS } from './registry'

function StepSpinner() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500" />
    </div>
  )
}

export default function StepLoader() {
  const { stepId } = useParams<{ stepId: string }>()

  if (!stepId || !STEP_COMPONENTS[stepId]) {
    return <Navigate to="/onboarding/step/set_institution_details" replace />
  }

  const StepComponent = STEP_COMPONENTS[stepId]

  return (
    <Suspense fallback={<StepSpinner />}>
      <StepComponent />
    </Suspense>
  )
}
